import { SalesTeam } from '@user/store/salesTeam'
import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { LeadAssignmentRuleFormModel } from '../typings'
import { ISalesFunnel } from '@user/store/salesFunnel'
import { useGetSalesTeamUsersMultiple } from '@user/store/salesTeam/hooks/useGetSalesTeamUsersMultiple'

export function useHandlers(onClose?: () => void) {
  const {
    setValues,
    resetForm,
    values: { salesTeamIds },
  } = useFormikContext<LeadAssignmentRuleFormModel>()

  const { execute: loadSalesTeamUsersMultiple, status } =
    useGetSalesTeamUsersMultiple(salesTeamIds)

  const onCloseNoSubmit = useCallback(() => {
    if (onClose) {
      resetForm()
      onClose()
    }
  }, [onClose, resetForm])

  const onChangeSalesTeam = useCallback(
    (value: SalesTeam[] | null) => {
      setValues((v) => ({
        ...v,
        ownerIds: [],
        salesTeamIds: value?.map((team) => team.id) ?? [],
      }))
      if (value && value.length > 0) {
        loadSalesTeamUsersMultiple(value.map((team) => team.id))
      }
    },
    [setValues, loadSalesTeamUsersMultiple],
  )

  const onChangeSalesFunnel = useCallback(
    (value: ISalesFunnel) => {
      setValues((v) => ({
        ...v,
        leadStatusId: '',
        salesFunnelId: value ? value.id : '',
      }))
    },
    [setValues],
  )

  return {
    onChangeSalesTeam,
    onCloseNoSubmit,
    onChangeSalesFunnel,
    status,
  }
}
